let activeSelect = null;

/**
 * Init all "select" components
 *
 * @export Initialization function
 */
export function init() {
  const selects = cube.$class('dkt-select');

  if (!selects) return;

  [...selects].forEach((select, index) => {
    select.addEventListener('click', handler);
    createHiddenInput(select, index);
  });

  document.addEventListener('click', closeSelect);
}

/**
 * Handle events
 *
 * @param {Event}
 */
function handler(e) {
  let element = e.target;
  activeSelect = this;

  if (!this.classList.contains('dkt-select--open')) e.stopPropagation();

  if (!element.classList.contains('dkt-select__option'))
    element = element.closest('.dkt-select__option');

  if(element) {
    if(this.$('.dkt-select__option--selected')) cube.$('.dkt-select__option--selected').classList.remove('dkt-select__option--selected');
    element.classList.add('dkt-select__option--selected');
  }

  if (element) setValue(element);
  else openSelect();
}

/**
 * Show option list
 *
 */
function openSelect() {
  if (activeSelect) activeSelect.classList.add('dkt-select--open');
}

/**
 * Hide option list
 *
 */
function closeSelect() {
  if (activeSelect) activeSelect.classList.remove('dkt-select--open');
}

/**
 * Set option "data-value" as input "value"
 * if "data-label" exists when selected the displayed label is equal to it value
 * if "data-selected" exists the input and displayed label is initialized with its data
 *
 * @param {HTMLElement} element Selected option
 * @param {Boolean} initialization Prevent the event dispatch when "input" is initialized
 * @returns
 */
function setValue(element, initialization) {
  const input = activeSelect.$('input');
  const selected = activeSelect.$class('dkt-select__value')[0];
  const { dataset } = element;
  let label;

  // Do nothing when selected option "data-value" is equal to current "input value" //
  if (dataset.value === input.value) return;

  Object.keys(dataset).forEach(data => {
    const value = dataset[data];

    if (data === 'value') input.value = value;
    else if (data === 'label') label = value;
    else if (data !== 'selected') input.dataset[data] = value;
  });

  selected.innerHTML = label || element.innerHTML;

  if (!initialization) input.dispatchEvent(new CustomEvent('change'));

  closeSelect();
}

/**
 * Create an hidden input
 *
 * @param {HTMLElement} select "select" component
 * @param {Integer} index "select" component index
 */
function createHiddenInput(select, index) {
  const { name } = select.dataset;
  const input = document.createElement('input');

  input.type = 'hidden';
  input.id = `dkt-select-${ name || index + 1}`;
  if (name) input.name = name;

  select.appendChild(input);

  activeSelect = select;

  [...select.$class('dkt-select__option')].some(
    option => option.hasAttribute('data-selected') && setValue(option, true)
  );
}



// WEBPACK FOOTER //
// ./src/commons/select.js